export const classScheduleType = (type, item) =>{
    let data = {
        Blocked: "view-info-no-disponible",
        Pagada: "view-info-programado",
        OnDemand: 'view-info-ondemand',
        Cancelada: 'view-info-cancelado',
        Pendiente: 'view-info-pendiente',
        Reagendada: 'view-info-reagendada',
        Fallida: 'view-info-fallida',
        CanceladaSinPago: 'view-info-canceladasinpago',
        PendientePago: 'view-info-pendientepago',
        Consultorio: 'view-info-consultorio',
        NoAtendida: 'view-info-consultorio',
    }
    if(type==='Online' && item.appointment?.appointmentStatus === 'NoAtendida'){
        return 'view-info-programado'
    }else if(type==='Consultorio' && item.appointment?.appointmentStatus === 'NoAtendida'){
        return 'view-info-consultorio'
    }else if((type==='Online' && item.appointment) || (type==='Consultorio' && item.appointment?.appointmentStatus === 'Fallida' )){
        return data[item.appointment.appointmentStatus] || ''
    }else if(type==="OnDemand"){
        return data[type]
    }else{
        return data[type] || ''
    }

    
}